export enum ProcedureType {
    CPT = 1,
    HCPCS = 2,
    ICD = 3,
    DRG = 4,
    APC = 5,
}

export interface RsProcedureMasterModel {
    id: number;
    procedureCode: string;
    longDescription: string;
    longDescriptionUpper: string;
    mediumDescription: string;
    shortDescription: string;
    consumerDescriptor: string;
    version: string;
    type: number;
    createdAt: Date;
    updatedAt: Date;
}
